export default function stringEmptyToHypen(text){
    return text !== "" ? text : "-"

}

